<app-header></app-header>
<!-- <app-header [navClass]="'nav-light'" [buttonList]="buttonShow" [sliderTopbar]="TopbarShow" 
[isdeveloper]="developerPage" [shopPages]="shopPages" [appicons]="appicons" [Nfticons]="Nfticons" [Menuoption]="'center'" [Settingicon]="true"></app-header> -->

<router-outlet (activate)="ngAfterViewInit($event)"></router-outlet>

<app-footer [footerVariant]="footerClass" [hideFooter]="hideFooter"></app-footer> 
